<app-playground [backgrounds]="['https://www.poettinger.at/img/myPoettinger/Hilfe/Kontakt_2000x1000px.jpg']"
    title="FAQs">
</app-playground>

<div class="container space mt-5">

    <div class="pb-4">
        <strong class="pb-2">{{ 'faqsTitle' | translate }}</strong>
    </div>

    <div>
        <div>
            <div class="title">{{ 'faq.1Title' | translate }}</div>
            <div>{{ 'faq.1Body' | translate }}</div>
        </div>
        <div>
            <div class="title">{{ 'faq.2Title' | translate }}</div>
            <div>{{ 'faq.2Body' | translate }}</div>
        </div>
        <div>
            <div class="title">{{ 'faq.3Title' | translate }}</div>
            <div>{{ 'faq.3Body' | translate }}</div>
        </div>
        <div>
            <div class="title">{{ 'faq.4Title' | translate }}</div>
            <div>{{ 'faq.4Body' | translate }}</div>
        </div>
        <div>
            <div class="title">{{ 'faq.5Title' | translate }}</div>
            <div [innerHTML]="'faq.5Body' | translate"></div>
        </div>
        <div>
            <div class="title">{{ 'faq.6Title' | translate }}</div>
            <div [innerHTML]="'faq.6Body' | translate"></div>
        </div>
        <div>
            <div class="title">{{ 'faq.7Title' | translate }}</div>
            <div [innerHTML]="'faq.7Body' | translate"></div>
        </div>
        <div>
            <div class="title">{{ 'faq.8Title' | translate }}</div>
            <div>{{ 'faq.8Body' | translate }}</div>
        </div>
    </div>
</div>